/** 模板前缀 */
export const TEMPLATE_PREFIX = {
  BILIBILI_PROMOTION: 'blibili_promotion', // B站 - 三连推广

  GDT_V3: 'gdt_v3', // 广点通 - 3.0

  BAIDU_FLOW: 'baidu_flow', // 百度 - 信息流
};

/** 渠道接口 */
export const CHANNEL_INTERFACE_TYPE = {
  JRTT: 'jrtt',
  JRTT_V3: 'jrtt_v3',
  GDT: 'gdt',
  BAIDU: 'baidu',
  BILIBILI: 'bilibili',
  KUAISHOU: 'kuaishou',
  HUAWEI: 'huawei',
  OPPO: 'oppo',
  VIVO: 'vivo',
  XIAOMI: 'xiaomi',
};

/** 渠道名称 */
export const CHANNEL_INTERFACE_TEXT = {
  JRTT: '今日头条',
  JRTT_V3: '今日头条智擎版',
  GDT: '广点通',
  BAIDU: '百度',
  BILIBILI: 'B站',
  KUAISHOU: '快手',
  HUAWEI: '华为',
  OPPO: 'OPPO',
  VIVO: 'VIVO',
  XIAOMI: '小米',
};

/** 自定义选项 */
export const OPTIONS_TYPE = {
  UNLIMITED: '_UNLIMITED', // 不限
  CUSTOM: '_CUSTOM', // 自定义
};

/** 时间序列长度 */
export const TIME_PERIOD_LENGTH = {
  HOUR: 24 * 7,
  HALF_HOUR: 24 * 2 * 7,
};

/** 资源类型 */
export const ADVERTISER_SOURCE_TYPE = {
  NATIVE_ANCHOR: 'native_anchor',
  SITE: 'site',
};

/** 资源名称 */
export const ADVERTISER_SOURCE_TEXT = {
  NATIVE_ANCHOR: '原生锚点',
  SITE: '落地页',
};
